export default __webpack_public_path__ + "static/media/promo-undesirable-no-1_04.c1303cb3.jpg";